export const getFormattedDeliveryDate = (message: string, deliveryTime: string) => {
  if (!message) return deliveryTime

  const trimmedDeliveryTime = deliveryTime?.trim()
  const parsedDate = trimmedDeliveryTime?.endsWith('Z') ? new Date(trimmedDeliveryTime) : null
  const expectedTime = parsedDate && !Number.isNaN(parsedDate.getTime())
    ? useDeliveryTime(parsedDate)
    : deliveryTime

  return replaceAll(
    message,
    { expectedTime }
  )
}
